<template>
  <button
    :id="id"
    class="roomie-button"
    :class="setClasses"
    :aria-label="ariaLabel"
    :type="type"
    @click="$emit('click', $event)">
    <span
      v-if="$slots.icon && iconPlacement === 'left'"
      class="roomie-icon">
      <slot name="icon" />
    </span>
    <span
      class="roomie-button__content"
      :class="setContentClasses">
      <slot />
    </span>
    <span
      v-if="$slots.icon && iconPlacement === 'right'"
      class="roomie-icon">
      <slot name="icon" />
    </span>
  </button>
</template>

<script>
import { SIZE, VARIANT, ICON_PLACEMENT, TYPE } from './utils'
export { SIZE, TYPE, VARIANT, ICON_PLACEMENT } from './utils'

export default {
  name: 'RoomieButton',
  props: {
    ariaLabel: {
      type: String,
      default: ''
    },
    id: {
      type: String,
      default: 'roomie-button',
      required: true
    },
    type: {
      type: String,
      default: 'button',
      validator: (value) => Object.keys(TYPE).includes(value),
      required: false
    },
    tabindex: {
      type: Number,
      default: 0
    },
    size: {
      type: String,
      default: 'md',
      validator: (value) => Object.keys(SIZE).includes(value),
      required: false
    },
    variant: {
      type: String,
      default: 'filled',
      validator: (value) => Object.keys(VARIANT).includes(value),
      required: false
    },
    iconPlacement: {
      type: String,
      default: '',
      validator: (value) => value === '' || Object.keys(ICON_PLACEMENT).includes(value)
    },
    fullWidth: {
      type: Boolean,
      default: false
    }
  },
  emits:['click'],
  computed: {
    setClasses() {
      return {
        'roomie-button--sm' : this.size === 'sm',
        'roomie-button--md' : this.size === 'md',
        'roomie-button--lg' : this.size === 'lg',
        'roomie-button--filled' : this.variant === 'filled',
        'roomie-button--outlined' : this.variant === 'outlined',
        'roomie-button--ghost' : this.variant === 'ghost',
        'roomie-button--primary' : this.variant === 'primary',
        'roomie-button--secondary' : this.variant === 'secondary',
        'roomie-button--tertiary' : this.variant === 'tertiary',
        'roomie-button--accent' : this.variant === 'accent',
        'roomie-button--full-width': this.fullWidth
      }
    },
    setContentClasses() {
      return {
        'icon-placement-left': this.iconPlacement === 'left',
        'icon-placement-right': this.iconPlacement === 'right'
      }
    }
  }
}
</script>

<style
  src="./_index.scss"
  lang="scss"/>
